import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";
import Loader from "../components/Loader";

const RootRouter = ({ component: Component, layout: Layout, protectedUrl = false, adminProtectedUrl = false, ...rest }) => {
  const { isAuthenticated, loading, user } = useSelector(({ auth }) => auth);

  const pathname = window.location.pathname.split("/")[1];
  const isAdminPath = pathname === "admin";
  const role = String(user?.role || "").toLowerCase();
  const isAdminUser = !!(user?.isSuperAdmin || role === "admin" || role === "superadmin");
  const isLoggedIn = isAuthenticated === true;

  return (
    <Route
      {...rest}
      render={(props) => {
        const currentPath = props?.location?.pathname || window.location.pathname || "";
        const adminPublicPrefixes = ["/admin/login", "/admin/forgot-password", "/admin/reset-password"];
        const isAdminPublic = adminPublicPrefixes.some((p) => currentPath.startsWith(p));
        const loginPath = isAdminPath ? "/admin/login" : "/login";

        if (loading && (protectedUrl || (isAdminPath && !isAdminPublic))) {
          return (
            <Layout>
              <Loader />
            </Layout>
          );
        }

        if (protectedUrl && !isLoggedIn) {
          return (
            <Redirect
              to={{
                pathname: loginPath,
                state: { from: currentPath },
              }}
            />
          );
        }

        if (isAdminPath && !isAdminPublic) {
          if (!isLoggedIn) {
            return <Redirect to="/admin/login" />;
          }
          if (!isAdminUser) {
            return <Redirect to="/admin/login" />;
          }
        }

        if (!isAdminPath && isLoggedIn && isAdminUser) {
          return <Redirect to="/admin" />;
        }

        if (adminProtectedUrl && isLoggedIn && !isAdminUser) {
          return <Redirect to="/admin/login" />;
        }

        return (
          <Layout>
            <Component {...props} />
          </Layout>
        );
      }}
    />
  );
};

export default RootRouter;
